import { ToursApiKey } from './api';
import { createEditorToEditorTour } from './tours/editorToEditorTour.conf';

import type { EditorAPI } from '@/editorAPI';
import type { StartOrigin } from './tours/tours.types';

export const startEditorToEditorTour = async (
  editorAPI: EditorAPI,
  startOrigin?: StartOrigin,
) => {
  const tourApi = editorAPI.host.getAPI(ToursApiKey);
  const editorToEditorTour = tourApi.createTour((shell) =>
    createEditorToEditorTour(shell, startOrigin),
  );

  return await tourApi.startTour(editorToEditorTour);
};
